import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlacePosterImages = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['posterImages'] =>
  getPlace(placeKey)(store).posterImages;
